<template>
    <vgloballayout :loading="loading" :error="error" @reload="vacancyGet">
        <div slot=body>
            <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="12">
                    <h1>Вакансии</h1>
                </el-col>
                <el-col :span="12" class="m-t-15" style="text-align: right">
                    <el-button size="small" @click="addNews" type="primary">Добавить вакансию</el-button>
                </el-col>
            </el-row>
            <el-table :data="getVacancy.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
                empty-text="Вакансии отсутствуют" style="width: 100%">
                <el-table-column label="#" prop="id">
                </el-table-column>
                <el-table-column label="Дата" prop="date">
                    <template slot-scope="scope">
                        {{ dateReturnFormat(scope.row.date) }}

                    </template>
                </el-table-column>
                <el-table-column label="Заголовок" prop="name">
                </el-table-column>
                <el-table-column width="240">
                    <template slot="header">
                        <el-input v-model="search" size="mini" placeholder="Поиск" />
                    </template>

                    <template slot-scope="scope">
                        <el-row type="flex" class="row-bg" justify="space-between">

                            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">
                                Редактировать
                            </el-button>
                            <el-button size="mini" type="danger" @click="deleteItem(scope.$index, scope.row)">
                                Удалить
                            </el-button>
                        </el-row>
                    </template>

                </el-table-column>
            </el-table>
        </div>
    </vgloballayout>
</template>

<script>
import { mapGetters } from 'vuex'
import { dateReturnFormat } from '@/plugins/methods'
export default {
    data() {
        return {
            loading: false,
            error: false,
            search: '',
        }
    },
    mounted() {
        this.vacancyGet()
    },
    computed: {
        ...mapGetters([
            'getVacancy'
        ])
    },
    methods: {
        dateReturnFormat(date) {
            return dateReturnFormat(date)
        },
        async vacancyGet() {
            this.loading = true
            this.error = false

            try {
                await this.$store.dispatch('vacancyGet')
            } catch (e) {
                this.error = this.$ErrorsMod(e)
            }

            this.loading = false
        },

        handleEdit(index, row) {
            this.$router.push({ path: '/vacancies/edit/' + row.id })
        },

        addNews() {
            this.$router.push({ path: '/vacancies/add' })
        },

        async deleteItem(index, row) {

            this.$confirm(`Вы действительно хотите удалить вакансию ?`, 'Подтвердите действие', {
                confirmButtonText: 'Удалить',
                cancelButtonText: 'Отменить',
                type: 'warning'
            }).then(async () => {
                try {
                    await this.$store.dispatch('vacancyDelete', {
                        id: row.id,
                        index: index
                    })
                } catch (e) {
                    this.$ErrorsMod(e)
                }
            })

        },
    },
    components: {

    }
}
</script>
